import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _SharingModalPresenter;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import partial from 'lodash/partial';
import debounce from 'lodash/debounce';
import { Modal, ModalHeader, ModalBody, ModalFooter, CAN_EDIT, READ_ONLY, REMOVED_ACCESS, SHARED_WITH_USER, SHARED_WITH_COURSE, SHARED_WITH_ACCOUNT, SimpleSelect, withStyleOverrides, TextInput } from '@instructure/quiz-common';
import { Heading } from '@instructure/ui-heading';
import { Button, CloseButton, CondensedButton, IconButton } from '@instructure/ui-buttons';
import { View } from '@instructure/ui-view';
import { Grid } from '@instructure/ui-grid';
import { Tabs } from '@instructure/ui-tabs';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import CustomPropTypes from '../../../common/util/CustomPropTypes';
import ShareList from './ShareList';
import AsyncSearch from '../AsyncSearch';
import RootAccountSharing from './RootAccountSharing';
import Spinner from '../../../common/components/shared/spinner/Spinner';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { IconSearchLine, IconTroubleLine } from '@instructure/ui-icons';
var noop = function noop() {};
export var SharingModalPresenter = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_SharingModalPresenter = /*#__PURE__*/function (_Component) {
  // =============
  //   LIFECYCLE
  // =============

  function SharingModalPresenter(props) {
    var _this2;
    _classCallCheck(this, SharingModalPresenter);
    _this2 = _callSuper(this, SharingModalPresenter, [props]);
    _defineProperty(_this2, "state", {
      accountPermission: null,
      shares: List(),
      newEntities: List(),
      searchSelection: [],
      searchPermission: READ_ONLY,
      selectedTabIndex: 0,
      value: '',
      startingPoint: 0,
      numOfResults: 0,
      searchValue: '',
      displayEntities: []
    });
    _defineProperty(_this2, "shareListRef", null);
    _defineProperty(_this2, "shareButtonRef", null);
    _defineProperty(_this2, "checkForSharedBanks", function () {
      var size = _this2.props.sharedBanks.size;
      if (size >= 0 && size !== _this2.props.bank.sharedCount || size === 0) {
        _this2.props.getSharedBanks(_this2.props.bank, _this2.props.getUserInfo, _this2.props.getCourseInfo, _this2.props.getSubaccountInfo);
      } else {
        _this2.setState({
          shares: _this2.props.sharedBanks
        });
      }
    });
    _defineProperty(_this2, "normalizeText", function (text) {
      return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    });
    // =============
    //   HELPERS
    // =============
    _defineProperty(_this2, "createFilteredList", function () {
      var entities = _this2.state.shares;
      var users = entities.filter(function (s) {
        return s.get('entityType') === SHARED_WITH_USER;
      });
      var courses = entities.filter(function (s) {
        return s.get('entityType') === SHARED_WITH_COURSE;
      });
      var accounts = entities.filter(function (s) {
        return s.get('entityType') === SHARED_WITH_ACCOUNT;
      });
      switch (_this2.state.selectedTabIndex) {
        case 0:
          {
            var displayedUsers = users.filter(function (item) {
              return _this2.normalizeText(item.get('title')).includes(_this2.normalizeText(_this2.state.searchValue));
            });
            _this2.setState({
              numOfResults: displayedUsers.size,
              displayEntities: displayedUsers.slice(0, _this2.state.startingPoint + _this2.props.limit)
            });
            _this2.debouncedStopLoading();
            break;
          }
        case 1:
          {
            var displayedCourses = courses.filter(function (item) {
              return _this2.normalizeText(item.get('title')).includes(_this2.normalizeText(_this2.state.searchValue));
            });
            _this2.setState({
              numOfResults: displayedCourses.size,
              displayEntities: displayedCourses.slice(0, _this2.state.startingPoint + _this2.props.limit)
            });
            _this2.debouncedStopLoading();
            break;
          }
        case 2:
          {
            var displayedAccounts = accounts.filter(function (item) {
              return _this2.normalizeText(item.get('title')).includes(_this2.normalizeText(_this2.state.searchValue));
            });
            _this2.setState({
              numOfResults: displayedAccounts.size,
              displayEntities: displayedAccounts.slice(0, _this2.state.startingPoint + _this2.props.limit)
            });
            _this2.debouncedStopLoading();
            break;
          }
      }
    });
    _defineProperty(_this2, "handleTabChange", function (event, _ref) {
      var index = _ref.index;
      _this2.setState({
        selectedTabIndex: index,
        startingPoint: 0,
        value: ''
      }, function () {
        _this2.checkForSharedBanks();
      });
    });
    _defineProperty(_this2, "modalDismissCleanup", function () {
      var focusCreateBank = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this2.props.onDismiss();
      if (_this2.props.modalTrigger && !focusCreateBank) {
        _this2.props.modalTrigger.focus();
      } else {
        setTimeout(_this2.props.focusCreateBankButton, 100);
      }
      // removes the creator's temporary sharedBank record
      _this2.props.removeSharedBank('-1');
    });
    _defineProperty(_this2, "isSharedWithAccount", function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.state;
      return [READ_ONLY, CAN_EDIT].includes(state.accountPermission);
    });
    // =============
    //   HANDLERS
    // =============
    _defineProperty(_this2, "handleDismiss", function (e) {
      _this2.props.updateSharedCount(null);
      _this2.modalDismissCleanup();
    });
    _defineProperty(_this2, "handleSearchSelectionChange", function (searchSelection) {
      _this2.setState({
        searchSelection: searchSelection
      });
    });
    _defineProperty(_this2, "originalPermissionForEntity", function (entity) {
      var originalEntity = _this2.props.sharedBanks.find(function (sb) {
        return sb.get('id') == entity.get('id');
      }) || Map();
      return originalEntity.get('permission', CAN_EDIT);
    });
    _defineProperty(_this2, "handleEntityRemove", function (entity, undoRemove) {
      _this2.confirmPermissionChange(entity, REMOVED_ACCESS);
    });
    _defineProperty(_this2, "handleSearchPermissionChange", function (e, _ref2) {
      var value = _ref2.value;
      _this2.setState({
        searchPermission: value
      });
    });
    _defineProperty(_this2, "handleSearchFilter", function (searchResults) {
      return searchResults.filter(function (result) {
        return !_this2.props.sharedBanks.some(function (entity) {
          return entity.get('entityId') === result.uuid;
        }) && (result.uuid !== _this2.props.bank.creator || _this2.props.bank.sharedCount > 0);
      });
    });
    _defineProperty(_this2, "handleShare", function () {
      var newEntities = List(_this2.state.searchSelection.map(function (entity) {
        return Map({
          id: entity.uuid,
          entityType: entity.entityType,
          entityId: entity.uuid,
          title: entity.fullName || entity.title || entity.name,
          avatar: entity.avatar,
          email: entity.email,
          permission: _this2.state.searchPermission
        });
      }));
      newEntities.forEach(function (entity) {
        _this2.props.onShare(entity.toJS());
        _this2.props.shareBank(_this2.sharedBankForEntity(entity), _this2.props.getUserInfo);
      });
      _this2.setState({
        searchSelection: []
      });
    });
    _defineProperty(_this2, "updatePermission", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(entity, permission) {
        var _this2$props, updateSharedBankPermission, getBank, bank;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2$props = _this2.props, updateSharedBankPermission = _this2$props.updateSharedBankPermission, getBank = _this2$props.getBank, bank = _this2$props.bank;
              _context.next = 3;
              return updateSharedBankPermission(bank.id, entity.get('id'), permission);
            case 3:
              getBank(bank.id); // make sure the user still has access to the bank
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this2, "translatedPermissionLevel", function (permission) {
      return _defineProperty(_defineProperty({}, CAN_EDIT, t('edit')), READ_ONLY, t('view'))[permission];
    });
    _defineProperty(_this2, "confirmPermissionChange", function (entity, permission) {
      var confirmText = permission === REMOVED_ACCESS ? t('You are about to remove { accessLevel } access for { entityTitle } to this bank.', {
        accessLevel: _this2.translatedPermissionLevel(_this2.originalPermissionForEntity(entity)),
        entityTitle: entity.get('title')
      }) : t('You are about to change access level for { entityTitle } from { originalAccessLevel } to { permission }.', {
        entityTitle: entity.get('title'),
        originalAccessLevel: _this2.translatedPermissionLevel(_this2.originalPermissionForEntity(entity)),
        permission: _this2.translatedPermissionLevel(permission)
      });
      _this2.props.withConfirm(partial(_this2.updatePermission, entity, permission), {
        title: t('Change Permission'),
        text: confirmText,
        continueText: t('Confirm')
      });
    });
    _defineProperty(_this2, "handleEntityPermissionChange", function (entity, permission) {
      _this2.confirmPermissionChange(entity, permission);
    });
    _defineProperty(_this2, "toggleAccountShare", function (event) {
      _this2.setState(function (prevState) {
        return {
          accountPermission: _this2.isSharedWithAccount(prevState) ? REMOVED_ACCESS : READ_ONLY
        };
      });
    });
    _defineProperty(_this2, "handleAccountPermissionChange", function (e, _ref4) {
      var value = _ref4.value;
      return _this2.setState({
        accountPermission: value
      });
    });
    _defineProperty(_this2, "handleShareButtonRef", function (node) {
      _this2.shareButtonRef = node;
    });
    _defineProperty(_this2, "handleChange", function (e, value) {
      _this2.setState({
        value: value
      });
    });
    _defineProperty(_this2, "handleClear", function (e) {
      e.stopPropagation();
      _this2.handleChange(e, '');
    });
    _defineProperty(_this2, "renderSearchSection", function (searchType) {
      if (_this2.props.bank.canEdit()) {
        return jsx(React.Fragment, null, jsx(Grid, {
          vAlign: "bottom",
          colSpacing: "small"
        }, jsx(Grid.Row, null, jsx(Grid.Col, null, jsx(AsyncSearch, {
          getShareableCourses: _this2.props.getShareableCourses,
          getShareableUsers: _this2.props.getShareableUsers,
          getShareableSubaccounts: _this2.props.getShareableSubaccounts,
          minChars: _this2.props.minChars,
          onSelectionChange: _this2.handleSearchSelectionChange,
          searchType: searchType,
          selectedOption: _this2.state.searchSelection,
          selectionFilter: _this2.handleSearchFilter
        })), jsx(Grid.Col, {
          width: "auto"
        }, jsx(SimpleSelect, {
          onChange: _this2.handleSearchPermissionChange,
          value: _this2.state.searchPermission,
          renderLabel: t('Access')
        }, jsx(SimpleSelect.Option, {
          id: "sharing-modal-search-section-select-option-can-view",
          value: READ_ONLY
        }, t('Can view')), jsx(SimpleSelect.Option, {
          id: "sharing-modal-search-section-select-option-can-edit",
          value: CAN_EDIT
        }, t('Can edit')))), jsx(Grid.Col, {
          width: "auto"
        }, jsx(Button, {
          "data-automation": "sdk-shared-bank-add-user-button",
          ref: _this2.handleShareButtonRef,
          onClick: _this2.handleShare,
          color: _this2.state.searchSelection.length ? 'success' : 'secondary'
        }, t('Add'))))), jsx("div", {
          css: _this2.props.styles.separator
        }));
      }
    });
    _defineProperty(_this2, "renderShareList", function () {
      if (_this2.props.loading) {
        return jsx(View, {
          height: "12em",
          as: "div"
        }, jsx(View, {
          position: "absolute",
          as: "div",
          insetBlockEnd: "0"
        }, jsx(Spinner, {
          renderTitle: "Loading...",
          size: "small",
          fontSize: "medium"
        })));
      }
      if (_this2.state.displayEntities.size > 0) {
        return jsx(View, {
          height: "12em",
          overflowY: "auto",
          overflowX: "hidden",
          as: "div",
          padding: "xx-small xx-small none"
        }, jsx(ShareList, {
          canEdit: _this2.props.bank.canEdit(),
          entities: _this2.state.displayEntities,
          onPermissionChange: _this2.handleEntityPermissionChange,
          onEntityRemove: _this2.handleEntityRemove,
          sharedBanks: _this2.props.sharedBanks
        }), jsx("div", null, _this2.renderShowMoreButton()));
      }
      return jsx(View, {
        height: "12em",
        as: "div"
      }, t('No results found'));
    });
    _defineProperty(_this2, "showMoreResult", function () {
      _this2.setState({
        startingPoint: _this2.state.startingPoint + _this2.props.limit
      });
    });
    _defineProperty(_this2, "renderShowMoreButton", function () {
      var shouldShowButton = _this2.state.startingPoint + _this2.props.limit < _this2.state.numOfResults;
      if (!shouldShowButton) {
        return null;
      }
      return jsx(View, {
        css: {
          display: shouldShowButton
        },
        background: "primary",
        padding: "small none",
        as: "div"
      }, jsx(CondensedButton, {
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          _this2.showMoreResult();
        }
      }, t('Show more')));
    });
    _defineProperty(_this2, "renderClearButton", function () {
      if (!_this2.state.value.length || _this2.state.readOnly || _this2.state.disabled) return null;
      return jsx(IconButton, {
        type: "button",
        size: "small",
        withBackground: false,
        withBorder: false,
        screenReaderLabel: "Clear search",
        disabled: _this2.state.disabled || _this2.state.readOnly,
        onClick: _this2.handleClear
      }, jsx(IconTroubleLine, null));
    });
    _defineProperty(_this2, "renderSharedSearch", function () {
      return jsx(View, {
        margin: "none large none medium"
      }, jsx(TextInput, {
        size: 'medium',
        placeholder: t('Search...'),
        value: _this2.state.value,
        onChange: _this2.handleChange,
        interaction: 'enabled',
        inputRef: function inputRef(el) {
          return _this2.inputRef = el;
        },
        renderBeforeInput: jsx(IconSearchLine, {
          inline: false
        }),
        renderAfterInput: _this2.renderClearButton(),
        shouldNotWrap: true
      }));
    });
    _this2.debouncedSearch = debounce(function () {
      _this2.setState({
        searchValue: _this2.state.value
      });
    }, 300);
    _this2.debouncedStopLoading = debounce(function () {
      if (_this2.props.loading != false) _this2.props.changeSharedBankLoading(false);
    }, 300);
    return _this2;
  }
  _inherits(SharingModalPresenter, _Component);
  return _createClass(SharingModalPresenter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        accountPermission: this.props.bank.accountPermission,
        shares: this.props.sharedBanks
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        accountPermission: nextProps.bank.accountPermission,
        shares: nextProps.sharedBanks
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.accountPermission !== prevState.accountPermission && this.state.accountPermission !== this.props.bank.accountPermission) {
        var updatedBank = this.props.bank.set('accountPermission', this.state.accountPermission);
        this.props.updateBank(updatedBank, false);
      }
      if (prevState.value !== this.state.value) {
        if (this.props.loading == false) this.props.changeSharedBankLoading(true);
        this.setState({
          startingPoint: 0
        });
        this.debouncedSearch();
      }
      if (prevState.searchValue !== this.state.searchValue || prevState.startingPoint !== this.state.startingPoint || prevState.selectedTabIndex !== this.state.selectedTabIndex || prevState.shares.size !== this.state.shares.size) {
        this.createFilteredList();
      }
    }
  }, {
    key: "sharedBankForEntity",
    value: function sharedBankForEntity(entity) {
      return {
        entityType: entity.get('entityType'),
        entityId: entity.get('entityId'),
        title: entity.get('title'),
        bankId: this.props.bank.id,
        permission: entity.get('permission')
      };
    }
  }, {
    key: "renderRootAccountSharing",
    value:
    // =============
    //   RENDERING
    // =============

    function renderRootAccountSharing() {
      var _this$props$currentUs;
      return jsx(RootAccountSharing, {
        accountName: (_this$props$currentUs = this.props.currentUser) === null || _this$props$currentUs === void 0 ? void 0 : _this$props$currentUs.account_name,
        onShareChange: this.toggleAccountShare,
        onShareTypeChange: this.handleAccountPermissionChange,
        accountPermission: this.state.accountPermission
      });
    }
  }, {
    key: "renderSubaccountSharingEnabledEntities",
    value: function renderSubaccountSharingEnabledEntities(existingPeople, existingCourses, existingAccounts) {
      var currentUser = this.props.currentUser;
      return jsx(View, {
        as: "div",
        "data-automation": "sdk-shared-bank-user-list"
      }, jsx(Tabs, {
        onRequestTabChange: this.handleTabChange
      }, jsx(Tabs.Panel, {
        renderTitle: t('People ({ peopleCount })', {
          peopleCount: existingPeople.size
        }),
        isSelected: this.state.selectedTabIndex === 0,
        padding: "large small small small"
      }, this.renderSearchSection(SHARED_WITH_USER), jsx(Text, {
        as: "div",
        weight: "bold",
        lineHeight: "double"
      }, t('Currently shared with')), this.renderSharedSearch(), this.renderShareList()), jsx(Tabs.Panel, {
        renderTitle: t('Courses ({ coursesCount })', {
          coursesCount: existingCourses.size
        }),
        isSelected: this.state.selectedTabIndex === 1,
        padding: "large small small small"
      }, this.renderSearchSection(SHARED_WITH_COURSE), jsx(Text, {
        as: "div",
        weight: "bold",
        lineHeight: "double"
      }, t('Currently shared with')), this.renderSharedSearch(), this.renderShareList()), ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.bank_admin) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.can_share_banks_with_subaccounts)) && jsx(Tabs.Panel, {
        renderTitle: t('Accounts ({ accountsCount })', {
          accountsCount: existingAccounts.size
        }),
        isSelected: this.state.selectedTabIndex === 2,
        padding: "large small small small"
      }, (currentUser === null || currentUser === void 0 ? void 0 : currentUser.bank_admin) && this.renderRootAccountSharing(), (currentUser === null || currentUser === void 0 ? void 0 : currentUser.can_share_banks_with_subaccounts) && this.renderSearchSection(SHARED_WITH_ACCOUNT), jsx(Text, {
        as: "div",
        weight: "bold",
        lineHeight: "double"
      }, t('Currently shared with')), this.renderSharedSearch(), this.renderShareList())));
    }
  }, {
    key: "renderEntitiesSection",
    value: function renderEntitiesSection() {
      var newEntityIds = this.state.newEntities.map(function (e) {
        return e.get('id');
      });
      var existingShares = this.state.shares.filterNot(function (s) {
        return newEntityIds.includes(s.get('id'));
      });
      var existingPeople = existingShares.filter(function (s) {
        return s.get('entityType') === SHARED_WITH_USER;
      });
      var existingCourses = existingShares.filter(function (s) {
        return s.get('entityType') === SHARED_WITH_COURSE;
      });
      var existingAccounts = existingShares.filter(function (s) {
        return s.get('entityType') === SHARED_WITH_ACCOUNT;
      });
      return this.renderSubaccountSharingEnabledEntities(existingPeople, existingCourses, existingAccounts);
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      return jsx(Button, {
        color: "primary",
        margin: "0 x-small 0 0",
        onClick: this.handleDismiss
      }, t('Close'));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Modal, {
        open: this.props.isOpen,
        onDismiss: this.handleDismiss,
        size: "medium",
        label: t('Sharing'),
        shouldCloseOnDocumentClick: true,
        onOpen: this.checkForSharedBanks
      }, jsx(ModalHeader, null, jsx(Heading, null, this.props.bank.title), jsx(CloseButton, {
        onClick: this.handleDismiss,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), jsx(ModalBody, null, this.state.shares.size >= 0 ? this.renderEntitiesSection() : jsx(Spinner, null)), jsx(ModalFooter, null, this.renderFooter()));
    }
  }]);
}(Component), _defineProperty(_SharingModalPresenter, "displayName", 'SharingModalPresenter'), _defineProperty(_SharingModalPresenter, "componentId", "Quizzes".concat(_SharingModalPresenter.displayName)), _defineProperty(_SharingModalPresenter, "propTypes", {
  appContainer: CustomPropTypes.selectors.isRequired,
  bank: ImmutablePropTypes.record.isRequired,
  currentUser: PropTypes.shape({
    bank_admin: PropTypes.bool,
    can_share_banks_with_subaccounts: PropTypes.bool,
    email: PropTypes.string,
    enrollment_names: PropTypes.arrayOf(PropTypes.string),
    full_name: PropTypes.string,
    uuid: PropTypes.string,
    account_name: PropTypes.string
  }),
  focusCreateBankButton: PropTypes.func.isRequired,
  getBank: PropTypes.func.isRequired,
  getShareableCourses: PropTypes.func.isRequired,
  getCourseInfo: PropTypes.func.isRequired,
  getShareableUsers: PropTypes.func.isRequired,
  getSharedBanks: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  getShareableSubaccounts: PropTypes.func.isRequired,
  getSubaccountInfo: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  minChars: PropTypes.number,
  modalTrigger: PropTypes.node,
  // html or react element that triggered this Modal
  onDismiss: PropTypes.func,
  onShare: PropTypes.func,
  removeSharedBank: PropTypes.func.isRequired,
  shareBank: PropTypes.func.isRequired,
  sharedBanks: ImmutablePropTypes.list,
  updateBank: PropTypes.func.isRequired,
  updateSharedBankPermission: PropTypes.func.isRequired,
  updateSharedCount: PropTypes.func,
  withConfirm: PropTypes.func.isRequired,
  styles: PropTypes.object,
  limit: PropTypes.number,
  loading: PropTypes.bool,
  changeSharedBankLoading: PropTypes.func.isRequired
}), _defineProperty(_SharingModalPresenter, "defaultProps", {
  bank: null,
  currentUser: null,
  isOpen: false,
  minChars: void 0,
  modalTrigger: null,
  onDismiss: noop,
  onShare: function onShare() {},
  sharedBanks: List(),
  updateSharedCount: Function.prototype,
  limit: 10,
  loading: false
}), _SharingModalPresenter)) || _class);
export default SharingModalPresenter;